import React, { Component } from 'react';
import AppConf from './AppConf';
import AppNav from './AppNav';
import Login from './views/Login';
import {
  firebaseDb,
  firebaseAuth,
} from './lib/firebase/firebase';
import './resources/css/App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn:false,
      loadedCookie:false,
    };
  }

  componentDidMount(){
    var _self = this;
    firebaseAuth.onAuthStateChanged((user) => {
      if(user){ // if user is logged in
        firebaseDb.ref('users/'+user.uid).once('value',function(s){
          _self.setState({isLoggedIn:true,loadedCookie:true,user:s.val()})
        })
      }else{
        _self.setState({isLoggedIn:false,loadedCookie:true,user:undefined,})
      }
    })
  }

  render() {
    if(!this.state.loadedCookie){
      return (
        <div className="App-loading-container">
          <div className="App-loading" ></div>
        </div>
      );
    }else{
      if(this.state.isLoggedIn){
        return (
          <AppNav 
            appConf={AppConf}
            user={this.state.user}/>
        );
      }else{
        return (
          <Login />
        );
      }
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js